export default __webpack_public_path__ + "static/media/image-1.3a7291e9.jpg";